import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeCompanyLogo, uploadCompanyLogo } from '../api/companyLogoApi';
import { companyDetailKeys } from './useCrmCompanyDetail';

/** The estimate editor shows the company logo too (and decks use it): refresh both. */
const ESTIMATES_KEY = ['estimates'] as const;

function useRefreshCompany(companyId: string) {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: companyDetailKeys.detail(companyId) });
    void queryClient.invalidateQueries({ queryKey: ESTIMATES_KEY });
  };
}

export function useUploadCompanyLogo(companyId: string) {
  const refresh = useRefreshCompany(companyId);
  return useMutation({ mutationFn: (file: File) => uploadCompanyLogo(companyId, file), onSuccess: refresh });
}

export function useRemoveCompanyLogo(companyId: string) {
  const refresh = useRefreshCompany(companyId);
  return useMutation({ mutationFn: () => removeCompanyLogo(companyId), onSuccess: refresh });
}
